import { LazyLoadImage } from "react-lazy-load-image-component";
import config from '../../config/config.json'
import { useTranslation } from "react-i18next";
export default function JoinUs(){
    const { t } = useTranslation();
    
    const exploreBtnClick = () => {
      window.open(config.workdayUrl, "_blank")
    }
    return(
        <article>
          <section class="what-we-do join-us mt-5">
            <div class="container">
              <div class="content-wrapper">
                <div class="gptw-logo">
                  <LazyLoadImage src={require("../../images/gptw_logo.png")} />
                </div>
                <div class="row align-centre">
                  <div class="col-md-6">
                    <div class="join-centrico">
                      <h2>{t('home.vibrantworkplace.joincentrico')} <span>INDIA</span></h2>
                      <div class="description">{t('home.vibrantworkplace.join_description')}</div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="container-box">
                      <div class="title">{t('home.vibrantworkplace.wearehiring')}</div>
                      <div class="btn-container">
                        <button class="btn c-button c-gradient" onClick={exploreBtnClick}>{t('home.vibrantworkplace.explorejobs')}</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </article>
    )
}